import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export { TOASTR_CONFIG } from '@core/configs/app.constants';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toastr: ToastrService
  ) { } // end constructor

  /** Success **/
  success(title: string = '', message: string = '') {
    return this.toastr.success(message, title);
  }
  error(title: string = '', message: string = '') {
    return this.toastr.error(message, title);
  }
  warning(title: string = '', message: string = '') {
    return this.toastr.warning(message, title);
  }
  info(title: string = '', message: string = '') {
    return this.toastr.info(message, title);
  }
}